module.exports = __webpack_public_path__ + "img/code-compare.d025f1d3.svg";